import Vue from 'vue';
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';
import $utils from "@/lib/utils/index.js";

const contractInfo = require('./TokenSwap.json')

let web3 = $web3js.getWeb3();

let contractAddress = $bizConfig.tokenSwapContractAddress;
let contractConst = {
  contract: web3 ? new web3.eth.Contract(contractInfo.abi, contractAddress) : '',
}

const getTokenSwapAddress = () => {
  return contractAddress;
}

const getTokenSwapContract = () => {
  return contractConst.contract;
}

const getTokenPair = ([_pid], options) => {
  return $web3js.call(getTokenSwapContract().methods.getTokenPair, [_pid], options, handlegetTokenPair);
}

const handlegetTokenPair = async (res) => {
  let index = 0;
  let token1 = res[index++];
  let minAmount = res[index++];
  let symbol2 = res[index++];
  minAmount = await $erc20.fromErc20Value(minAmount, token1);

  if ("IXCH" == symbol2) {
    symbol2 = "XCH"
  }

  return {
    token1,
    symbol2,
    minAmount
  }
}

const setMinAmount = async ([_pid, _minAmount, _contractAddress], options, callback) => {
  _minAmount = await $erc20.toErc20Value(_minAmount, _contractAddress);
  return $web3js.send(getTokenSwapContract().methods.setMinAmount, [_pid, _minAmount], options, callback);
}

const swap = async ([_pid, _from, _to, _amount, _contractAddress], options, callback) => {
  _amount = await $erc20.toErc20Value(_amount, _contractAddress);
  return $web3js.send(getTokenSwapContract().methods.swap, [_pid, _from, _to, _amount], options, callback);
}

const swapEstimateSend = async ([_pid, _from, _to, _amount, _contractAddress], options) => {
  _amount = await $erc20.toErc20Value(_amount, _contractAddress);

  let gasPromise = $web3js.estimateSend(getTokenSwapContract().methods.swap, [_pid, _from, _to, _amount], options);
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return { gas, gasPrice, fee };
}

export default {
  getTokenSwapAddress,
  getTokenSwapContract,
  getTokenPair,
  setMinAmount,
  swap,
  swapEstimateSend,
}


// WEBPACK FOOTER //
// ./src/lib/contract/tokenSwap/index.js